import { useId } from 'react'
import { topicsCopy } from '@/copy'
import type { AgentDefInfo } from '@/types/api'
import { EmptyState } from '@/ui/EmptyState/EmptyState'
import { CheckboxField, CheckboxGroup } from '@/ui/Field/Field'
import { Text } from '@/ui/layout/Text'

/**
 * The agent checkboxes shared by New topic and Topic settings. `locked` is the
 * dependency lock (`aria-disabled`, still focusable), with `lockedReason`
 * under the legend.
 */
export function AgentPicker({
  legend,
  help,
  agents,
  selected,
  onToggle,
  locked,
  lockedReason,
  emptyText,
}: {
  legend: string
  help?: string
  agents: readonly AgentDefInfo[]
  selected: readonly string[]
  onToggle: (agentId: string) => void
  locked?: boolean
  lockedReason?: string
  emptyText: string
}) {
  const idPrefix = useId()
  return (
    <CheckboxGroup
      label={legend}
      help={help}
      locked={locked}
      lockedReason={lockedReason}
    >
      {agents.length === 0 ? (
        <EmptyState variant="inline" description={emptyText} />
      ) : (
        agents.map((a) => (
          <CheckboxField
            key={a.agent_id}
            id={`${idPrefix}-${a.agent_id}`}
            label={
              <>
                {a.name}
                {a.status === 'paused' && (
                  <>
                    {' '}
                    <Text variant="caption" tone="text-mute">
                      {topicsCopy.agentPaused}
                    </Text>
                  </>
                )}
              </>
            }
            checked={selected.includes(a.agent_id)}
            onChecked={() => onToggle(a.agent_id)}
          />
        ))
      )}
    </CheckboxGroup>
  )
}
